const USER_ACTIONS = {
  USER_LOADED: 'USER_LOADED',
  USER_STATS_LOADED: 'USER_STATS_LOADED',
  CLAIMS_LOADED: 'CLAIMS_LOADED',
  FIREBASE_USER_LOADED: 'FIREBASE_USER_LOADED',
  USER_LOGOUT: 'USER_LOGOUT',
  INVALID_USER: 'INVALID_USER',
  SWITCH_ORGANISATION: 'SWITCH_ORGANISATION'
};

const userSwithOrganisationAction = ({ organisationId }) => {
  return {
    type: USER_ACTIONS.SWITCH_ORGANISATION,
    payload: { organisationId }
  };
};

const userLoadedAction = user => {
  return {
    type: USER_ACTIONS.USER_LOADED,
    payload: user
  };
};

const userLogoutAction = () => {
  return { type: USER_ACTIONS.USER_LOGOUT };
};

const userStatsLoadedAction = userStats => {
  return {
    type: USER_ACTIONS.USER_STATS_LOADED,
    payload: { userStats }
  };
};

export {
  userLoadedAction,
  userStatsLoadedAction,
  userLogoutAction,
  userSwithOrganisationAction
};

export default USER_ACTIONS;
